import { render, staticRenderFns } from "./ChargeBack.vue?vue&type=template&id=b0520b4c&scoped=true&"
import script from "./ChargeBack.vue?vue&type=script&lang=js&"
export * from "./ChargeBack.vue?vue&type=script&lang=js&"
import style0 from "./ChargeBack.vue?vue&type=style&index=0&id=b0520b4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0520b4c",
  null
  
)

export default component.exports